import React, { useEffect, useState } from "react";

import { handlePrioridadeSCColumn }  from "../GridCell/Solicitacao";
import ResponsiveDataTable from "../DataTable";
import { formatDateColumn } from "../../contents/VariaveisGlobais";
import { Row, Col } from "react-bootstrap";
import { handleCCPCColumn, handleNumeroItemPCColumn, handleProdutoPCColumn, handleSaldoPC, handleSaldoPCColumn, handleSaldoPrecoPC } from "../GridCell/Pedido";

const SelecaoPedidoCompra = (DisparaBootBox, FecharBox, dataPedidoCompra, tipo = "P") => {
    let columns = [
        { Header: 'PC',                 accessor: "C7_NUM",         },
        { Header: 'Emissão',            accessor: 'C7_EMISSAO',     Cell: formatDateColumn },
        { Header: 'Saldo',              accessor: "SALDO",          Cell: handleSaldoPC },
    ];

    if (tipo === 'I'){
        columns = [
            { Header: 'PC',                 accessor: "C7_NUM",         Cell: handleNumeroItemPCColumn},
            { Header: 'Produto/Serviço',    accessor: "C7_PRODUTO",     Cell: handleProdutoPCColumn },
            { Header: 'Prioridade',         accessor: "C7_XFLUXSC",     Cell: handlePrioridadeSCColumn },
            { Header: 'Saldo Pedido',       accessor: 'C7_QUANT',       Cell: (item) => handleSaldoPrecoPC(item, dataPedidoCompra) },
            { Header: 'Qtde',               accessor: 'QTDSEL',         Cell: (item) => handleSaldoPCColumn(item, dataPedidoCompra) },
            { Header: 'Emissão',            accessor: 'C7_EMISSAO',     Cell: formatDateColumn },
            { Header: 'Previsão',           accessor: 'C7_DATPRF',      Cell: formatDateColumn },
        ];
    }

    const Mensagem = (
        <Row>
            <Col md="12" xs="12">
                <ResponsiveDataTable
                    columns={columns}
                    data={dataPedidoCompra} // Carregar dados conforme necessário
                    buttons={[]}
                    isIgnorar={true}
                    habilitaCheckBox={true}
                />
            </Col>
        </Row>
    );

    const buttonsRender = [
        { variant: 'primary', action: FecharBox, label: 'Aplicar' }
    ];

    DisparaBootBox('Selecione o(s) Item(ns) do Pedido(s) de Compra(s)', Mensagem, buttonsRender, 0, FecharBox, 'xl', false);
};

export default SelecaoPedidoCompra;